import styled from 'styled-components';
import { margin, MarginProps, padding, PaddingProps } from 'styled-system';

type SectionDivider = MarginProps & PaddingProps;

export const SectionDivider = styled.div<SectionDivider>`
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray.extraLight};
  ${margin};
  ${padding};
`;
